// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__CIJMx","boxTitle":"Qualiphy_boxTitle__ixRne","box":"Qualiphy_box__3sY8-","toggleWrap":"Qualiphy_toggleWrap__2PttM"};